// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import { fetchWrapper } from 'helpers/api'

export const fetchAnalysisTypes = () => fetchWrapper('/analysis-types')
